import request from '../../js/lib/request';

const forms = document.querySelectorAll('.limraForm');

const options = {
	headers: {
		"content-type": "application/json; charset=utf-8"
	}
};

if(forms.length > 0)
{
	for(var x=0; x<forms.length; x++)
	{
		const id = forms[x].id;

		const triggerForm = new Vue({
			el: '#' + id,
			data: {
				isLoading: false,
			},

			mounted: function() {
				const self = this;

				// fill data sets
				const trigger = self.$el.getAttribute('data-trigger');

				if(trigger == "watch") // form setup
				{
					const fInputs = document.querySelectorAll('.form__input');

					for (var x = 0; x < fInputs.length; x++) 
					{
						fInputs[x].addEventListener('blur', ($event) => {
							self.watchForm($event);
						});
					}
				}
				if(trigger == "submit") // form setup
				{
					const fInputs = document.querySelectorAll('.form__submit');

					for (var x = 0; x < fInputs.length; x++) 
					{
						['click', 'keypress'].forEach((listener) => {
							fInputs[x].addEventListener(listener, ($event) => {
								self.submitForm($event);
							})
						});
					}
				}
			},
			methods: {
				submitForm: function(e) {
					const self = this;

					if(!self.isLoading)
					{
						self.isLoading = true;

						if (e.type === 'keypress' && e.keyCode === 13) {
							self.$refs.contactForm.submit();
						}
						else if (e.type === 'click') {
							self.$refs.contactForm.submit();
						}

						setTimeout(() => { self.isLoading = false; }, 5000);
					}
				},

				watchForm: function(e) {
					const self = this;

					const fInputs = document.querySelectorAll('.form__input');

					var formData = {};
					for (var x = 0; x < fInputs.length; x++) 
						formData[fInputs[x].getAttribute('name')] = fInputs[x].getAttribute('value');

					if(!self.isLoading)
					{
						self.isLoading = true; // these variables are for timing.  don't do another request to the server while one is taking place
						var isToasting = false; // or, while toasting

						request(options).post(self.$el.getAttribute('data-watchHref'), JSON.stringify(formData)).then(function(response) {
							for (var x = 0; x < response.length; x++) 
							{
								// get any messages the server wants to display to the user and set them to client id's
								const message = document.getElementById(response[x].clientID);
								message.innerHTML = response[x].message;

								// toast message, special event to target the flash updater
								if(response[x].clientID == 'toast')
								{
									isToasting = true;
									const toast = document.getElementById('toast_wrap');
									toast.setAttribute('class', 'toast_animate');
									setTimeout(() => { toast.removeAttribute('class', 'toast_animate'); self.isLoading = false; }, 5000); // timeout for toast animation
								}
							}

							if(!isToasting)
								self.isLoading = false;
						});
					}
				},
			}
		});
	}
}



// WEBPACK FOOTER //
// ../components/form-watcher/form-watcher.js